<script>
import moment from 'moment'
import $const from '@/utils/const'

export default {
    data () {
        let ruleRequired = v => (v !== null && v !== undefined && v !== '') || this.$t('formRules.fieldRequired')
        let ruleCounter = count => {
            return v => {
                if (v && v.length > count) {
                    return this.$t('formRules.fieldTooLong', [count])
                }
                return true
            }
        }
        let regProjectName = /^[a-zA-Z\d._\- ]+$/
        let ruleProjectName = v => regProjectName.test(v) || this.$t('projectNameInvalid')
        let ruleDateTime = dateTime => moment(dateTime).isValid() || this.$t('formRules.dateTimeNotCorrect')
        let ruleDate = date =>
            moment(date, this.$const.dateFormat, true).isValid() ||
            this.$t('formRules.dateTimeNotCorrect')
        let ruleTime = time => /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(time) || this.$t('formRules.timeNotCorrect')
        let ruleNumber = value => /^[0-9]*$/.test(value) || this.$t('formRules.numberNotValid')
        let rulePositiveNumber = value => !!(/^[0-9]*$/.test(value) && parseInt(value) > -1) || this.$t('formRules.positiveNumberNotValid')
        let ruleKeyFormat = value => /^\w+$/.test(value) || this.$t('formRules.formatKeyNotValid')
        let ruleDatePicker = date =>
            moment(date, $const.DATE_FORMAT, true).isValid() ||
            this.$t('formRules.dateNotCorrect')
        let rulePhone = v => (
            /^[0-9-+]{9,15}$/.test(v) ||
            this.$t('formRules.fieldNotValid', [this.$filters.capitalize(this.$t('phoneNumber'))])
        )
        let rulePhoneList = v => {
            if (!v) {
                return this.$t('formRules.fieldNotValid', [this.$t('phoneNumber')])
            }
            let phoneList = v.split(';')
            for (let phone of phoneList) {
                if (phone && /^[0-9-+]{10,15}$/.test(phone)) {
                    // good phone, continue to next phone
                } else if ((phone.substring(0, 2) === '62' || phone.substring(0, 3) === '+62' || phone.substring(0, 4) === '0062') && /^[0-9-+]{10,15}$/.test(phone)) {
                    // INDO phone
                } else if ((phone.substring(0, 3) === '855' || phone.substring(0, 4) === '+855' || phone.substring(0, 5) === '00855') && /^[0-9-+]{10,15}$/.test(phone)) {
                    // CAMPUCHIA phone
                } else if ((phone.substring(0, 3) === '856' || phone.substring(0, 4) === '+856' || phone.substring(0, 5) === '00856') && /^[0-9-+]{10,15}$/.test(phone)) {
                    // LAO phone
                } else {
                    return this.$t('formRules.fieldNotValid', [this.$t('phoneNumber')])
                }
            }
            return true
        }
        let ruleEmail = v => /.+@.+/.test(v) || this.$t('formRules.fieldNotValid', [this.$f.tc('email')])
        let ruleEmailList = v => {
            if (!v) {
                return this.$t('formRules.fieldNotValid', [this.$f.tc('email')])
            }
            let emailList = v.split(';')
            for (let email of emailList) {
                if (!email || !/.+@.+/.test(email)) {
                    return this.$t('formRules.fieldNotValid', [this.$f.tc('email')])
                }
            }
            return true
        }
        let ruleMin = min => {
            return v => {
                if (isNaN(v)) {
                    return this.$t('formRules.notANumber')
                }
                return Number(v) >= min || this.$t('formRules.minValue', [min])
            }
        }
        let ruleList = v => {
            if (!v) {
                return this.$t('formRules.fieldNotValid', [this.$f.tc('actionCodes')])
            }
            let list = v.split(';')
            for (let item of list) {
                if (item) {
                    // good string, continue to next string
                } else {
                    return this.$t('formRules.fieldNotValid', [this.$f.tc('actionCodes')])
                }
            }
        }

        return {
            formValid: false,
            formRules: {
                ruleRequired,
                ruleCounter,
                ruleProjectName,
                ruleDateTime,
                ruleDate,
                ruleTime,
                ruleNumber,
                rulePositiveNumber,
                ruleDatePicker,
                ruleKeyFormat,
                rulePhone,
                rulePhoneList,
                ruleEmail,
                ruleEmailList,
                ruleMin,
                ruleList,
                required: [ruleRequired],
                email: [ruleRequired, ruleEmail],
                projectName: [ruleRequired, ruleProjectName]
            }
        }
    },
    methods: {
        submit (event) {
            if (event) {
                event.preventDefault()
            }
            if (this.formValid) {
                this.submitValidForm()
            } else if (this.$refs.form) {
                this.$refs.form.validate()
            }
        },
        submitValidForm () {
        },
        clearForm () {
            this.$refs.form.reset()
        },
        setDefaultValue (otherModel = { nameProp: '' }, nameProp, defaultVal = '') {
            this.$nextTick(() => {
                otherModel[nameProp] = defaultVal
            })
        },
    }
}
</script>
